import React, { useState } from 'react';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';
import './Download.css';

import appIcon from './theApp.png';
import appStoreBadge from './appstore.png';
import googlePlayBadge from './googleplay.png';

const DownloadHomeSection = () => {
  const [showNotifyPopup, setShowNotifyPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleNotifyClick = () => {
    setShowNotifyPopup(true);
  };

  const closePopup = () => {
    setShowNotifyPopup(false);
    setEmail('');
  };

  const closeSuccessPopup = () => {
    setShowSuccessPopup(false);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const handleEmailSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      await addDoc(collection(db, 'waitlist'), {
        email: email.trim().toLowerCase(),
        timestamp: serverTimestamp(),
      });

      setIsLoading(false);
      closePopup();
      setShowSuccessPopup(true);
    } catch (error) {
      console.error('Error adding to waitlist:', error);
      setIsLoading(false);
      closePopup();
      setShowErrorPopup(true);
    }
  };

  return (
    <section className="download-app">
      <h2 className="download-heading">Our Mobile App is Coming Soon!</h2>

      <p className="download-desc">
        We&apos;re getting our mobile app ready. Gain rewards points, take advantage of limited time offers, and <span style={{ color: '#fff', fontWeight: 700 }}>order pickup in a few clicks</span> when it launches.
      </p>

      <img src={appIcon} alt="App Icon" className="download-app-icon" />

      <p className="download-subtitle">Coming soon for iPhone and Android.</p>

      <div className="download-stores">
        <img
          src={appStoreBadge}
          alt="Download on the App Store"
          className="store-badge"
        />

        <img
          src={googlePlayBadge}
          alt="Get it on Google Play"
          className="store-badge"
        />
      </div>

      <button className="notify-btn" onClick={handleNotifyClick}>
        Notify Me
      </button>

      {showNotifyPopup && (
        <div className="notify-overlay" onClick={closePopup}>
          <div className="notify-card" onClick={(event) => event.stopPropagation()}>
            {!isLoading ? (
              <>
                <h3 className="notify-title">Get Notified!</h3>
                <p className="notify-message">
                  Enter your email and we&apos;ll let you know when the app launches.
                </p>
                <form onSubmit={handleEmailSubmit}>
                  <input
                    type="email"
                    className="notify-email-input"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    required
                  />
                  <div className="notify-buttons">
                    <button type="submit" className="notify-submit-btn">
                      Notify Me
                    </button>
                    <button type="button" className="notify-cancel-btn" onClick={closePopup}>
                      Cancel
                    </button>
                  </div>
                </form>
              </>
            ) : (
              <div className="loading-spinner"></div>
            )}
          </div>
        </div>
      )}

      {showSuccessPopup && (
        <div className="notify-overlay" onClick={closeSuccessPopup}>
          <div className="notify-card success-card" onClick={(event) => event.stopPropagation()}>
            <div className="success-icon">✓</div>
            <h3 className="notify-title">Thank You!</h3>
            <p className="notify-message">
              We&apos;ll notify you when the app launches.
            </p>
            <button className="notify-submit-btn" onClick={closeSuccessPopup}>
              Got it
            </button>
          </div>
        </div>
      )}

      {showErrorPopup && (
        <div className="notify-overlay" onClick={closeErrorPopup}>
          <div className="notify-card error-card" onClick={(event) => event.stopPropagation()}>
            <div className="error-icon">✗</div>
            <h3 className="notify-title">Oops!</h3>
            <p className="notify-message">
              Sorry, there was an error. Please try again.
            </p>
            <button className="notify-submit-btn" onClick={closeErrorPopup}>
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default DownloadHomeSection;